<template>
  <article class="flex items-center justify-between gap-2 mb-0 sm:px-2 md:col-span-full md:px-12 md:col-start-2 lg:hidden">
    <h3 v-if="title" class="font-semibold text-sm leading-tight" :class="{ 'text-white': theme === 'red' }">
      <span v-if="eventDate" :class="[{ 'text-app-secondary-8-green--vista-blue': !theme }, 't-cdp-info-sticky-date-' + theme]">
        {{ $d(eventDate, 'short-date') }}
      </span>
      {{ title }}
    </h3>

    <MoleculeEventDetailOrderButtons :order-url="url" :stream-url="streamUrl" :sale-is-available="tixSaleIsAvailable" :concert-state="concertState" @order-click="orderClick" />
  </article>
</template>

<script setup lang="ts">
defineProps({
  eventDate: { type: Date, required: false, default: undefined },
  title: { type: String, required: false, default: undefined },
  url: { type: String, required: false, default: undefined },
  streamUrl: { type: String, required: false, default: undefined },
  tixSaleIsAvailable: { type: Boolean, required: false, default: undefined },
  concertState: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  theme: { type: String, required: false, default: undefined },
})

const emit = defineEmits(['orderClick'])

function orderClick() {
  emit('orderClick')
}
</script>

<style lang="scss"></style>
